// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2LH4b","header":"Messages_header__T89B_"};